/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Response for searching catalog properties.
 *
 * Identifier-resolution metadata attached to identifier-like searches.
 */
export type CatalogPropertySearchIdentifierResolution = {
    /**
     * Original query text received from the client.
     */
    query: string;
    /**
     * Whether exact identifier resolution succeeded or fell back to fuzzy search.
     */
    mode: CatalogPropertySearchIdentifierResolution.mode;
    /**
     * Whether exact identifier resolution matched multiple local properties.
     */
    isAmbiguous: boolean;
    /**
     * Property ids matched by exact identifier resolution, when available.
     */
    exactMatchedPropertyIds?: Array<number>;
};
export namespace CatalogPropertySearchIdentifierResolution {
    /**
     * Whether exact identifier resolution succeeded or fell back to fuzzy search.
     */
    export enum mode {
        EXACT = 'exact',
        FUZZY_FALLBACK = 'fuzzy_fallback',
    }
}

